/**
 * Navigation utility functions for handling returnToDashboard state
 */

/**
 * Get the appropriate back navigation path based on returnToDashboard state
 * @param {Object} location - React Router location object
 * @param {string} clubId - Club ID
 * @param {string} defaultPath - Default path if returnToDashboard is not set
 * @returns {Object} Navigation object with path and state
 */
export const getBackNavigation = (location, clubId, defaultPath = null) => {
  const returnToDashboard = location.state?.returnToDashboard;
  const returnTab = location.state?.returnTab || 'management';

  if (returnToDashboard && clubId) {
    // Navigate back to the club management page
    return {
      path: `/club-management/${clubId}`,
      state: {
        returnToDashboard: false // Reset flag
      }
    };
  }

  // Default navigation
  if (defaultPath) {
    return {
      path: defaultPath,
      state: {}
    };
  }

  // Fallback to club management
  if (clubId) {
    return {
      path: `/club-management/${clubId}`,
      state: {}
    };
  }

  return {
    path: '/',
    state: {}
  };
};

/**
 * Navigate back using the appropriate path based on returnToDashboard
 * @param {Function} navigate - React Router navigate function
 * @param {Object} location - React Router location object
 * @param {string} clubId - Club ID
 * @param {string} defaultPath - Default path if returnToDashboard is not set
 */
export const navigateBack = (navigate, location, clubId, defaultPath = null) => {
  const nav = getBackNavigation(location, clubId, defaultPath);
  const fullPath = nav.search ? `${nav.path}${nav.search}` : nav.path;
  navigate(fullPath, { state: nav.state });
};

